import React from 'react'
import { ArrowToTop } from '../assets/icons'

export default function Footer() {
    return (
        <div className='footer'>
            <div className='container'>
                <footer className="py-3" style={{ height: "100px" }}>

                    <div className="row text-light">
                        <div className="col-lg-10 text-start fw-bold">
                            <p>© {new Date().getFullYear()} - Region H
                            </p>
                        </div>
                        <div className="col-lg-2 text-end fw-normal">
                            <a href="#" className=" text-light"><ArrowToTop /> Back to top</a>
                        </div>
                    </div>

                </footer>
            </div>
        </div>
    )
}
